var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpFooterLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 13.375C28.2227 13.375 28.75 13.9023 28.75 14.5352V28C28.75 28.6328 28.2227 29.125 27.625 29.125H14.0898C13.4922 29.125 13 28.6328 13 28V14.5352C13 13.9023 13.4922 13.375 14.0898 13.375H27.625ZM17.7461 26.875V19.3867H15.4258V26.875H17.7461ZM16.5859 18.332C17.3242 18.332 17.9219 17.7344 17.9219 16.9961C17.9219 16.2578 17.3242 15.625 16.5859 15.625C15.8125 15.625 15.2148 16.2578 15.2148 16.9961C15.2148 17.7344 15.8125 18.332 16.5859 18.332ZM26.5 26.875V22.7617C26.5 20.7578 26.043 19.1758 23.6875 19.1758C22.5625 19.1758 21.7891 19.8086 21.4727 20.4062H21.4375V19.3867H19.2227V26.875H21.543V23.1836C21.543 22.1992 21.7188 21.25 22.9492 21.25C24.1445 21.25 24.1445 22.375 24.1445 23.2188V26.875H26.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpFooterLinkedInIcon);
export default __webpack_public_path__ + "static/media/DlpFooterLinkedInIcon.3dad79fba2ae2566290dece8a0c32ada.svg";
export { ForwardRef as ReactComponent };